module.exports = __webpack_public_path__ + "static/img/hot.74c40bb0.png";